import { render, staticRenderFns } from "./NewProducSalePrice.vue?vue&type=template&id=4588c03f&lang=pug&"
import script from "./NewProducSalePrice.vue?vue&type=script&lang=js&"
export * from "./NewProducSalePrice.vue?vue&type=script&lang=js&"
import style0 from "./NewProducSalePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewProducSalePrice.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
installComponents(component, {
  VAlert,
})
